import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setLoading } from "store/appSlice";

import General from "./components/general";
import { getSite } from "api/site";
import { Site } from "api/types/site";
import Rates from "./components/rates";
import Configuration from "./components/configuration";
import useViewportDimensions from "hooks/viewport-dimensions";
import Escalation from "./components/escalation";
import useWhiteLabel from "whitelabel/useWhiteLabel";
import NoRatesSvg from "assets/svg/no-rates1.svg";
import GenericCard from "widgets/cards/generic";

const Sites = () => {
  const { getControlHeight, dimensions } = useViewportDimensions();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { platform } = useWhiteLabel();
  // Extract the filter parameter
  const id = searchParams.get("id");

  const [site, setSite] = useState<Site>(null);
  const [refresh, setRefresh] = useState(0);

  const fetchData = async () => {
    dispatch(setLoading(true));
    const { data, status, isLoading } = await getSite(id);
    dispatch(setLoading(isLoading));
    if (status && status === 200) {
      setSite(data);
      setTimeout(() => setRefresh((r) => r + 1), 100);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const cardHeight = useCallback(() => {
    return dimensions.contentHeight - getControlHeight("see") - 15;
  }, [refresh]);

  return (
    <div className={`mt-0 grid w-full grid-cols-1 gap-y-4 px-2 md:px-4`}>
      <div id="see" className="flex flex-col gap-4 lg:flex-row">
        <General site={site} onUpdate={fetchData} />
        {platform !== "thermocloud" && (
          <Configuration site={site} onUpdate={fetchData} />
        )}
        <Escalation site={site} onUpdate={fetchData} />
      </div>
      <div
        className="flex flex-col gap-0 lg:flex-row"
        key={`chart-area-${refresh}`}
        style={{ height: cardHeight() }}
      >
        {platform !== "thermocloud" ? (
          <Rates site={site} onUpdate={fetchData} />
        ) : (
          <GenericCard
            extraDescription="text-secondary text-txt-sm"
            extra="h-full"
          >
            <div className="flex h-full w-full items-center justify-center">
              <img src={NoRatesSvg} alt="Modal content" />
            </div>
          </GenericCard>
        )}
      </div>
    </div>
  );
};

export default Sites;
